import React from 'react';
import { createPortal } from 'react-dom';
import { MdClose, MdTimer } from 'react-icons/md';
import './ComingSoonModal.css';

const ComingSoonModal = ({ isOpen, onClose, title = "Coming Soon", message = "We're working hard to bring this feature to you. Stay tuned!" }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="coming-soon-overlay" onClick={onClose}>
      <div className="coming-soon-content" onClick={(e) => e.stopPropagation()}>
        <button className="coming-soon-close" onClick={onClose} aria-label="Close">
          <MdClose />
        </button>
        <div className="coming-soon-icon-wrapper">
          <MdTimer className="coming-soon-icon" />
          <div className="coming-soon-pulse" />
        </div>
        <div className="coming-soon-badge">NEW FEATURE</div>
        <h2 className="coming-soon-title">{title}</h2>
        <p className="coming-soon-message">{message}</p>
        <button className="coming-soon-btn" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>,
    document.body
  );
};

export default ComingSoonModal;
